/* eslint-disable react-refresh/only-export-components -- a context's provider and its read hook belong together; the hook is not a component and has no Fast Refresh state to lose. */
import { createContext, useContext, type ReactNode } from 'react';
import type { ILogisticsRevisionHandle } from '@apis/logisticsRevision';

export interface ILogisticsEditLock {
  /** The page's revision, sent on its writes; null outside the page. */
  revision: ILogisticsRevisionHandle | null;
  /** The page is stale: forms already open keep their input, but may not save. */
  saveLocked: boolean;
  /** Nothing new may start: the page is stale or its first fetch has not yet
   *  settled the revision. The write controls a panel renders are disabled. */
  locked: boolean;
}

interface ILogisticsEditLockProviderProps {
  value: ILogisticsEditLock;
  children: ReactNode;
}

const LogisticsEditLockContext = createContext<ILogisticsEditLock>({ revision: null, saveLocked: false, locked: false });

export function LogisticsEditLockProvider({ value, children }: ILogisticsEditLockProviderProps) {
  return <LogisticsEditLockContext value={value}>{children}</LogisticsEditLockContext>;
}

export function useLogisticsEditLock(): ILogisticsEditLock {
  return useContext(LogisticsEditLockContext);
}
